module.exports = __webpack_public_path__ + "static/media/logo.e103de0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 607
// module chunks = 1